import type { GetImpactsResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetImpactsQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetImpactsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

export const useGetImpacts = createQueryHook<
  Record<string, never>,
  GetImpactsResponseRow[],
  GetImpactsQuery
>({
  trpcQueryOptions: (trpc) =>
    trpc.frontend.impact.impacts.queryOptions(),
  mapTrpcDataToGraphQL: (data) => ({ impact: data }),
  graphqlDocument: GetImpactsDocument,
});
